export enum MessageToBeDirectedTo
{ 
    CTGF = 1,
    Carrier = 2,
    Client = 3
}